module.exports = __webpack_public_path__ + "img/culture_bg.ee7eec7e.png";